import axios from 'axios';
import { getCookie } from "../components/LoginModal";
import http from './http';

export const getToken = async () => {
	const clientId = '2fog3rqqm9v5dnb9qgtpd8otrj';
	const clientSecret = '1260l6c0pmn6m4ssprar676j3e5goeio5p73m3p636p6ljo72c6l';
	const tokenUrl = 'https://us-west-2sshzqok5x.auth.us-west-2.amazoncognito.com/oauth2/token';
	
	const authHeader = btoa(`${clientId}:${clientSecret}`);
	const headers = {
		'Content-Type':'application/x-www-form-urlencoded',
		'Authorization': `Basic ${authHeader}`
        }; 
	const data = new URLSearchParams({
		grant_type : 'client_credentials'
	});
	const response = await axios.post(tokenUrl, data, {headers});
	return {
    access_token: response.data.access_token,
    expires_in: response.data.expires_in || 3600
  };
  ;
};

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});


export const logIn = async ({ login, password }) => {
  const url = '/login';
  const { data } = await http.post(url, { login, password },);
  return data;
};


export const createAccount = async (token, { login, password, nick, description }) => {
  const { data } = await http.post(
    '/createAccount',
    { login, password, nick, description }
  );
  return data;
};  

export const signOut = async (token) => {
  const url = '/logout'; // <-- adjust if you have one
  const { data } = await axios.post(url, {} );
  return data;
};

/*

export const logIn = async (token, { login, password }) => {
  const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/login';
  const { data } = await axios.post(url, { login, password }, { headers: authHeaders(token) });
  // expected: { token, expires_in, user: { id, login, nick, description } }
  return data;
};

// ---- 3) Create account (your /dev/createAccount lambda) ----
// (renamed to createAccount for clarity; use this instead of apiRegister/signOut)
export const createAccount = async (token, { login, password, nick, description }) => {
  const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/createAccount';
  const { data } = await axios.post(
    url,
    { login, password, nick, description },
    { headers: authHeaders(token) }
  );
  return data;
};

// If you truly have a sign-out endpoint, point it there. Otherwise remove it.
export const signOut = async (token) => {
  const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/logout'; // <-- adjust if you have one
  const { data } = await axios.post(url, {}, { headers: authHeaders(token) });
  return data;
};
*/